'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _UISlider = require('UIComponents/input/UISlider');

var _UISlider2 = _interopRequireDefault(_UISlider);

var _FormattedNumber = require('I18n/components/FormattedNumber');

var _FormattedNumber2 = _interopRequireDefault(_FormattedNumber);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('HubStyleTokens/colors');

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _PriceDisplay = require('./pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UINumberInput = require('UIComponents/input/UINumberInput');

var _UINumberInput2 = _interopRequireDefault(_UINumberInput);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _underscore = require('underscore');

var _merchandiseUtils = require('../../utils/merchandiseUtils');

var _ContactsSelectors = require('pricing-pages-unified-ui/selectors/ContactsSelectors');

var _PricingSelectors = require('../../selectors/PricingSelectors');

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _itemConfigUtils = require('../../utils/itemConfigUtils');

var _pricingUtils = require('../../utils/pricingUtils');

var _ContactConfirmationModal = require('../contacts-confirmation-page/ContactConfirmationModal');

var _ContactConfirmationModal2 = _interopRequireDefault(_ContactConfirmationModal);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _publicPageUrls = require('pricing-pages-unified-ui/utils/publicPageUrls');

var _Editions = require('self-service-api/constants/Editions');

var _ContactsInfoBox = require('./info-box/ContactsInfoBox');

var _ContactsInfoBox2 = _interopRequireDefault(_ContactsInfoBox);

var _ContactsMaxLimitContainer = require('./info-box/ContactsMaxLimitContainer');

var _ContactsMaxLimitContainer2 = _interopRequireDefault(_ContactsMaxLimitContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var throttleWait = 100;

var SliderLabel = (0, _styledComponents2.default)(_Small2.default).withConfig({
  displayName: 'ContactsPicker__SliderLabel'
})(['color:', ';flex:1;&:nth-child(2){text-align:right;}'], _colors.EERIE);

var SliderTitle = _styledComponents2.default.h5.withConfig({
  displayName: 'ContactsPicker__SliderTitle'
})(['font-weight:bold;display:inline-block;margin:0 16px 10px 0;']);

var SliderInput = (0, _styledComponents2.default)(_UINumberInput2.default).withConfig({
  displayName: 'ContactsPicker__SliderInput'
})(['display:inline-block;width:90px !important;height:30px !important;font-size:14px !important;text-align:right !important;']);

function ContactsPicker(_ref) {
  var additionalUnitQuantity = _ref.additionalUnitQuantity,
      onChange = _ref.onChange,
      merchandiseId = _ref.merchandiseId,
      term = _ref.term,
      termId = _ref.termId,
      pricingDependencies = _ref.pricingDependencies,
      minPurchasableContacts = _ref.minPurchasableContacts,
      moreDetailsGAClassName = _ref.moreDetailsGAClassName,
      setActiveEdition = _ref.setActiveEdition;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalVisible = _useState2[0],
      setModalVisible = _useState2[1];

  var edition = (0, _merchandiseUtils.merchandiseEdition)(merchandiseId);

  var currencyCode = pricingDependencies.currencyCode;


  var step = (0, _merchandiseUtils.contactsQuantityMultiplier)(merchandiseId);
  var max = (0, _merchandiseUtils.maxAdditionalUnits)(merchandiseId);
  var includedUnits = (0, _merchandiseUtils.includedAdditionalUnits)(merchandiseId);

  var numContacts = includedUnits + additionalUnitQuantity;

  var additionalUnitPrice = (0, _pricingUtils.calculatePrice)(_extends({}, pricingDependencies, {
    term: term,
    termId: termId,
    merchandiseId: merchandiseId,
    itemConfigurations: (0, _itemConfigUtils.defaultAdditionalContactsUnitItemConfig)(merchandiseId)
  })).monthly.calculatedPrice;

  var roundInput = (0, _underscore.throttle)(function (_ref2) {
    var value = _ref2.target.value;

    var roundedValue = Math.round(value / step) * step;
    if (roundedValue < minPurchasableContacts) return;
    if (roundedValue > max) return;
    onChange(roundedValue - includedUnits);
  }, throttleWait);

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      SliderTitle,
      null,
      _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.contacts.title' })
    ),
    _react2.default.createElement(
      _UIFlex2.default,
      {
        direction: 'row',
        justify: 'between',
        align: 'center',
        className: 'm-bottom-6'
      },
      _react2.default.createElement(
        _Small2.default,
        { style: { width: '70%' } },
        _react2.default.createElement(_FormattedJSXMessage2.default, {
          message: 'pricingPage.calculator.contacts.additionalContactsSubtext.' + edition + '_jsx',
          options: { price: additionalUnitPrice, currencyCode: currencyCode },
          elements: { PriceDisplay: _PriceDisplay2.default, FormattedNumber: _FormattedNumber2.default }
        }),
        merchandiseId === _MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            _UILink2.default,
            {
              onClick: function onClick() {
                setModalVisible(true);
                (0, _getUsageTracker2.default)().track('clickToViewModal', {
                  name: 'contact-pricing-details-modal'
                });
              },
              className: 'text-right m-left-1 ' + (0, _publicPageUrls.getGAClassName)(moreDetailsGAClassName)
            },
            _react2.default.createElement(_FormattedMessage2.default, {
              className: (0, _publicPageUrls.getGAClassName)(moreDetailsGAClassName),
              message: 'pricingPage.calculator.moreDetails'
            })
          )
        )
      ),
      _react2.default.createElement(SliderInput, {
        value: numContacts,
        onChange: roundInput,
        min: minPurchasableContacts,
        max: max,
        'data-selenium-id': 'contacts-picker-input'
      })
    ),
    _react2.default.createElement(_UISlider2.default, {
      className: 'm-y-4',
      size: 'large',
      step: step,
      trackStart: includedUnits,
      min: minPurchasableContacts,
      max: max,
      value: numContacts,
      onChange: (0, _underscore.throttle)(roundInput, throttleWait)
    }),
    _react2.default.createElement(
      _UIFlex2.default,
      null,
      _react2.default.createElement(
        SliderLabel,
        null,
        _react2.default.createElement(_FormattedNumber2.default, { value: includedUnits })
      ),
      _react2.default.createElement(
        SliderLabel,
        null,
        _react2.default.createElement(_FormattedNumber2.default, { value: max })
      )
    ),
    merchandiseId === _MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL && _react2.default.createElement(_ContactsInfoBox2.default, {
      titleKey: 'pricingPage.calculator.contacts.pricingTip.title',
      content: _react2.default.createElement(_FormattedJSXMessage2.default, {
        message: 'pricingPage.calculator.contacts.pricingTip.marketingProTip_jsx',
        elements: { UILink: _UILink2.default },
        options: { onClick: function onClick() {
            return setActiveEdition(_Editions.ENTERPRISE);
          } }
      }),
      showBox: numContacts === max
    }),
    merchandiseId === _MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE && _react2.default.createElement(_ContactsInfoBox2.default, {
      titleKey: 'pricingPage.calculator.contacts.upperLimitTip.title',
      content: _react2.default.createElement(_ContactsMaxLimitContainer2.default, null),
      showBox: numContacts === max
    }),
    modalVisible && _react2.default.createElement(_ContactConfirmationModal2.default, {
      currencyCode: currencyCode,
      termId: termId,
      handleModalClose: function handleModalClose() {
        return setModalVisible(false);
      }
    })
  );
}

var mapStateToProps = function mapStateToProps(state, _ref3) {
  var merchandiseId = _ref3.merchandiseId;
  return {
    pricingDependencies: (0, _PricingSelectors.pricingDependenciesSelector)(state),
    minPurchasableContacts: (0, _ContactsSelectors.minPurchasableContactsSelector)(state, merchandiseId)
  };
};

ContactsPicker.defaultProps = {
  // a bit hacky, but to get around how this is abstracted right now
  moreDetailsGAClassName: 'marketing-pricing-startercontacts'
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ContactsPicker);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/ContactsPicker.js
// module id = 212
// module chunks = 3 4